import {
  getClientOrganizationsFromState,
  getCurrentClientOrganizationIdFromState,
  getCurrentUserFromState,
} from 'app/app.selectors';

import { useSelector } from 'react-redux';
import {
  NORWAY_MAP_CENTER_COORDS,
  EUROPE_MAP_CENTER_COORDS,
} from 'app/app.constants';
import {
  DEFAULT_MAP_ZOOM,
  HOVER_MAP_ZOOM,
} from 'features/wells/wells.constants';

export const useCurrentUser = () => {
  const currentUser = useSelector(getCurrentUserFromState);

  return currentUser;
};

const useCurrentOrganization = () => {
  const clientOrganizations = useSelector(getClientOrganizationsFromState);
  const currentClientOrganizationId = useSelector(
    getCurrentClientOrganizationIdFromState,
  );
  const organization = clientOrganizations
    .toJS()
    .find(({ id }) => String(id) === currentClientOrganizationId);

  return organization;
};

export const useCurrentUserOrganizationLocation = () => {
  const currentUser = useCurrentUser();
  const organization = currentUser?.get('organization');
  const latitude = organization?.latitude;
  const longitude = organization?.longitude;
  return !longitude || !latitude
    ? EUROPE_MAP_CENTER_COORDS
    : [latitude, longitude];
};

export const useCurrentOrganizationMapZoomLevel = () => {
  const organization = useCurrentOrganization();

  return {
    mapZoomLevel: organization?.mapZoomLevel ?? DEFAULT_MAP_ZOOM,
    hoverMapZoomLevel: organization?.hoverMapZoomLevel ?? HOVER_MAP_ZOOM,
  };
};

export const useCurrentUserOrganizationLocationDefaultNordway = () => {
  const organization = useCurrentOrganization();
  const latitude = organization?.latitude;
  const longitude = organization?.longitude;

  return !longitude || !latitude
    ? NORWAY_MAP_CENTER_COORDS
    : [latitude, longitude];
};
